import React, { Component } from 'react';
import {ref} from '../config/firebase';
import Nav from './components/Nav';
import Footer from './components/Footer';
import {Tabs, Tab} from 'react-bootstrap';
import firebase from 'firebase';
import FileUploader from 'react-firebase-file-uploader';

import Error from '../helpers/Error';

export default class Portfolio extends Component {
    constructor(props) {
        super(props);
        this.state = {
            aKey: 1,
            items: [],
            edit: false,
            err: null,
            status: null,
            key: '',
            img1Progress: 0,
            img2Progress: 0,
            img1Url: '',
            img2Url: '',
            img1Upload: false,
            img2Upload: false
        };
        this.dbItems = ref.child('portfolio');
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }


    componentDidMount() {
        this.dbItems.on('value', dataSnapshot => {
            var items = [];
            dataSnapshot.forEach(function(childSnapshot) {

                var item = childSnapshot.val();

                item['.key'] = childSnapshot.key;
                items.push(item);

            });

            this.setState({items: items});

        });

    }

    componentWillUnmount() {
        this.dbItems.off();
    }

    handleSubmit(e) {
        e.preventDefault();

        if( this.type.value !== "" &&
            this.name.value !== "" &&
            this.usage.value !== "" &&
            this.description.value !== "" ) {

            if(this.state.edit) { // edit
                this.dbItems.child(this.state.key).update({
                    type: this.type.value,
                    name: this.name.value,
                    usage: this.usage.value,
                    description: this.description.value,
                    link: this.link.value,
                    img1: this.state.img1Url,
                    img2: this.state.img2Url
                });
                this.setState({
                    err: "Success Edit Portfolio!",
                    status: null,
                    edit: false,
                    key: ''
                });
                this.handleSelect(1);
            }
            else { // create
                this.dbItems.push({
                    type: this.type.value,
                    name: this.name.value,
                    usage: this.usage.value,
                    description: this.description.value,
                    link: this.link.value,
                    img1: this.state.img1Url,
                    img2: this.state.img2Url
                })

                this.setState({err: "Success Insert New Portfolio!", status: null});
            }

            // empth value
            this.type.value = '';
            this.name.value = '';
            this.usage.value = '';
            this.description.value = '';
            this.link.value = '';
            this.img1.value = '';
            this.img2.value = '';
            this.setState({
                img1Progress: 0,
                img2Progress: 0,
                img1Url: '',
                img2Url: '',
                img1Upload: false,
                img2Upload: false
            });

        }
        else {
            this.setState({err: "Something Wrong", status:'err'});
        }

    }

    removeItem(key) {
        this.dbItems.child(key).remove();
    }

    editItem(key) {
        this.dbItems.child(key).once('value', dataSnapshot => {

            var data = dataSnapshot.val();

            // set back value
            this.type.value = data.type;
            this.name.value = data.name;
            this.usage.value = data.usage;
            this.description.value = data.description;
            this.link.value = data.link;
            this.setState({
                img1Url: data.img1,
                img2Url: data.img2
            });

            this.handleSelect(2);

            this.setState({
                edit:true,
                key: key
            });
        });


    }

    handleSelect(aKey) {this.setState({aKey});}


    handleUploadStart = () => this.setState({ img1Upload: true, img1Progress: 0 });
    handleUploadStart2 = () => this.setState({ img2Upload: true, img2Progress: 0 });

    handleProgress = (img1Progress) => this.setState({img1Progress});
    handleProgress2 = (img2Progress) => this.setState({img2Progress});

    handleUploadError = (error) => {
        this.state({img1Upload: false});
        console.log(error);
    }

    handleUploadError2 = (error) => {
        this.state({img2Upload: false});
        console.log(error);
    }

    handleUploadSuccess = (filename) => {
        this.setState({
            img1Progress: 100,
            img1Upload: false
        });

        firebase.storage().ref('portfolio').child(filename)
            .getDownloadURL()
            .then(photoUrl => {
                this.setState({img1Url: photoUrl});
            });
    }
    handleUploadSuccess2 = (filename) => {
        this.setState({
            img2Progress: 100,
            img2Upload: false
        });

        firebase.storage().ref('portfolio').child(filename)
            .getDownloadURL()
            .then(photoUrl => {
                this.setState({img2Url: photoUrl});
            });
    }

    render () {
        var dat = [ 'Portfolio List', 'Create Portfolio' ];
        var i = 0;
        var _this = this;

        return (
            <div>
                <Nav />
                <div className="container">
                    <div className="row">
                        <h1>PORTFOLIO</h1>
                        <Error err={this.state.err} status={this.state.status}/>
                        <Tabs activeKey={this.state.aKey} onSelect={this.handleSelect} id="prtTab">
                            <Tab eventKey={1} title={dat[0]}>
                                <h3>{dat[0]}</h3>
                                <table className="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Type</th>
                                        <th>Name</th>
                                        <th>Cover Image</th>
                                        <th>Detail Image</th>
                                        <th>Description</th>
                                        <th>Usage</th>
                                        <th>Action</th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    {
                                        this.state.items.map(function(item) {

                                            return (
                                                <tr key={item['.key']}>
                                                    <td>{++i}.</td>
                                                    <td>{item.type}</td>
                                                    <td>{item.name}</td>
                                                    <td><img src={item.img1} alt="alt" width="150px"/></td>
                                                    <td><img src={item.img2} alt="alt" width="150px"/></td>
                                                    <td>{item.description}</td>
                                                    <td><a href={item.link} target="_blank" rel="noopener noreferrer">{item.usage}</a></td>
                                                    <td>
                                                        <a data-toggle="tab" className="btn btn-info" onClick={()=>{_this.editItem(item['.key'])}}>Edit</a> &nbsp;
                                                        <a className="btn btn-danger" onClick={() => { _this.removeItem(item['.key']) }}>Delete</a>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    }

                                    </tbody>
                                </table>
                            </Tab>

                            <Tab eventKey={2} title={(this.state.edit)? 'Edit Portfolio' : dat[1]}>
                                <h3>{(this.state.edit)? 'Edit Portfolio' : dat[1]}</h3>
                                <form onSubmit={this.handleSubmit}>
                                    <div className="form-group">
                                        <label>Type</label>
                                        <select ref={(type)=>this.type=type} className="form-control">
                                            <option value="">-Select One-</option>
                                            <option value="mobile">Mobile Application</option>
                                            <option value="web">Web Application</option>
                                            <option value="desktop">Desktop Application</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Name</label>
                                        <input type="text" ref={(name) => this.name = name} className="form-control" placeholder="Ex: BINET"/>
                                    </div>
                                    <div className="form-group">
                                        <label>Cover Image (Size: 620x450px)</label>
                                        {
                                            this.state.img1Upload &&
                                            <p>Progress: {this.state.img1Progress}</p>
                                        }
                                        {
                                            this.state.img1Url &&
                                            <img src={this.state.img1Url} width="150px" alt="file"/>
                                        }
                                        <FileUploader
                                            accept="*"
                                            ref={(img1) => this.img1 = img1}
                                            name="img1"
                                            randomizeFilename
                                            storageRef={firebase.storage().ref('portfolio')}
                                            onUploadStart={this.handleUploadStart}
                                            onUploadError={this.handleUploadError}
                                            onUploadSuccess={this.handleUploadSuccess}
                                            onProgress={this.handleProgress}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Detail Image (Size: 620x450px)</label>
                                        {
                                            this.state.img2Upload &&
                                            <p>Progress: {this.state.img2Progress}</p>
                                        }
                                        {
                                            this.state.img2Url &&
                                            <img src={this.state.img2Url} width="150px" alt="file"/>
                                        }
                                        <FileUploader
                                            accept="*"
                                            ref={(img2) => this.img2 = img2}
                                            name="img2"
                                            randomizeFilename
                                            storageRef={firebase.storage().ref('portfolio')}
                                            onUploadStart={this.handleUploadStart2}
                                            onUploadError={this.handleUploadError2}
                                            onUploadSuccess={this.handleUploadSuccess2}
                                            onProgress={this.handleProgress2}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Usage</label>
                                        <input type="text" ref={(usage) => this.usage = usage} className="form-control" placeholder="Ex: Internal Use Only"/>
                                    </div>
                                    <div className="form-group">
                                        <label>Link Usage</label>
                                        <input type="text" ref={(link) => this.link = link} className="form-control" placeholder="Empty the field if it's Internal Use Only"/>
                                    </div>
                                    <div className="form-group">
                                        <label>Description</label>
                                        <textarea ref={(description) => this.description = description} className="form-control" placeholder="Ex: BINET is an Web Application that created with Laravel (PHP Framework) version 4.2."></textarea>

                                    </div>

                                    <button type="submit" className="btn btn-default">{(this.state.edit)?'Edit':'Create'}</button> &nbsp;
                                    <button type="reset" className="btn btn-warning">Cancel</button>
                                </form>
                            </Tab>
                        </Tabs>

                    </div>
                </div>
                <Footer/>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/auth_pages/Portfolio.js